import {
	common_utils,
	RemoveVoid,
} from "../../../../../../common/common_utils";
import { RouterInferenceHelpers } from "../../../../../../src/api/trpc/rootRouter";
import { useError } from "../../../../calendar/hooks/useError";
import { trpc } from "../../../utils/trpc";
import { useServerId } from "./use_server_id";

export function usePublicCalendarQuery(
	params: RemoveVoid<RouterInferenceHelpers["calendar"]["view"]["input"]>
) {
	const error_context = useError();
	const server_id = useServerId();

	return trpc.calendar.view.useQuery(params, {
		staleTime: 5000,
		keepPreviousData: true,
		onError: (err: { data: any; message: any }) => {
			console.log(err.data.code);

			let text = err.message;
			if (err.data.code === "FORBIDDEN") {
				text = (
					<div className="flex flex-col items-center">
						{err.message}
						<div>
							If you are a member of this server, you can view the
							calendar{" "}
							<a
								className="manual-link"
								href={common_utils.getEventListURL(server_id)}
							>
								here
							</a>
							.
						</div>
					</div>
				);
			}

			error_context.setError({
				title: err.data.code,
				text,
			});
		},
	});
}
